/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import { useEffect } from 'react';
import Sidebar from '../../../components/Sidebar';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { InputFromUser } from '../../../components/Input/input';
import Header from '../../../components/Header';
import { DatePicker, Select, Spin } from 'antd';
import dayjs from 'dayjs';
import { ActionCreateCoupon, ActionUpdateCoupon, ActionGetCouponByID } from '../../../store/Actions/CouponAction';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  code: Yup.string().required('Coupon Code is required'),
  couponQuantity: Yup.number().required('Coupon Quantity is required').min(1, 'Quantity must be at least 1'),
  bookingFor: Yup.string().required('Service Type is required'),
  platformType: Yup.string().required('Platform Type is required'),
  type: Yup.string().required('Discount Type is required'),
  value: Yup.number()
    .typeError('Value must be a number')
    .required('Value is required')
    .when('type', {
      is: 'Percentage',
      then: schema =>
        schema
          .min(1, 'Percentage must be between 1 and 99')
          .max(99, 'Percentage must be between 1 and 99'),
      otherwise: schema => schema.min(1, 'Value must be at least 1'),
    }),
  dateRange: Yup.array().of(Yup.mixed()).required('Validity Period is required').nullable(),
  personUsageLimit: Yup.number().required('Per User Usage Limit is required').min(1, 'Limit must be at least 1'),
});


const { Option } = Select;

const AddCoupon = () => {
  const dispatch = useDispatch();
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  const updateValue = searchParams.get('update');
  const pageValue = searchParams.get('page') ? searchParams.get('page') : 1;
  const idValue = searchParams.get('id');

  useEffect(() => {
    if (idValue) {
      dispatch(ActionGetCouponByID({ Query: `/${idValue}` }));
    }
  }, [idValue, dispatch]);
  const { couponDetails, loader } = useSelector(state => state?.CouponManagement);
  return (
    <>
      <Header />
      <Sidebar />
      <>
        <div>
          <div className="page-wrapper">
            <div className="content">
              {/* Page Header */}
              <div className="page-header">
                <div className="row">
                  <div className="col-sm-12">
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/coupon-management">Coupon</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <i className="feather-chevron-right">
                          <FeatherIcon icon="chevron-right" />
                        </i>
                      </li>
                      <li className="breadcrumb-item active">Add Coupon</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="row">
                <div className="col-sm-12">
                  <Spin spinning={!!(loader && idValue)}>
                    <div className="card p-3">
                      <div className="card-body">
                        <Formik
                          enableReinitialize={updateValue}
                          initialValues={{
                            code: couponDetails?.code || '',
                            couponQuantity: couponDetails?.couponQuantity || '',
                            bookingFor: couponDetails?.bookingFor || '',
                            platformType: couponDetails?.platformType || '',
                            type: couponDetails?.type || '',
                            value: couponDetails?.value || '',
                            startDate: couponDetails?.startDate
                              ? dayjs(couponDetails?.startDate)
                              : null,
                            expiryDate: couponDetails?.expiryDate
                              ? dayjs(couponDetails?.expiryDate)
                              : null,
                            personUsageLimit: couponDetails?.personUsageLimit || '',
                            isActive: couponDetails?.isActive || true,
                            dateRange:
                              couponDetails?.startDate && couponDetails?.expiryDate
                                ? [
                                  dayjs(couponDetails?.startDate),
                                  dayjs(couponDetails?.expiryDate),
                                ]
                                : null,
                          }}
                          validationSchema={validationSchema}
                          onSubmit={(values, { setSubmitting, setErrors }) => {
                            const payload = {
                              ...values,
                              startDate: values.dateRange
                                ? values.dateRange[0]?.format('YYYY-MM-DD')
                                : '',
                              expiryDate: values.dateRange
                                ? values.dateRange[1]?.format('YYYY-MM-DD')
                                : '',
                            };
                            delete payload.dateRange;

                            if (!updateValue) {
                              dispatch(
                                ActionCreateCoupon(payload, Res => {
                                  setSubmitting(false);
                                  if (Res?.status === 200 || Res?.message === 'Coupon created successfully') {
                                    window.location.href = `/coupon-management?page=${pageValue}`;
                                  } else if (Res?.statusCode === 400) {
                                    setErrors(Res?.data?.errors);
                                  } else {
                                    // window.location.reload();
                                  }
                                })
                              );
                            } else {
                              dispatch(
                                ActionUpdateCoupon(
                                  {
                                    Query: '/' + idValue,
                                    obj: payload,
                                  },
                                  Res => {
                                    setSubmitting(false);
                                    if (Res?.status === 200 || Res?.message === 'Coupon updated successfully') {
                                      window.location.href = `/coupon-management?page=${pageValue}`;
                                    } else if (Res?.statusCode === 400) {
                                      setErrors(Res?.data?.errors);
                                    } else {
                                      // window.location.reload();
                                    }
                                  }
                                )
                              );
                            }
                          }}
                        >
                          {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            setFieldValue,
                            isSubmitting,
                          }) => {
                            return (
                              <div>
                                <div className="row">
                                  <div className="col-lg-12">
                                    <div className="form-heading">
                                      <h4>Add Coupon Data</h4>
                                    </div>
                                  </div>

                                  <div className="row">
                                    <InputFromUser
                                      placeholder={'Coupon Code'}
                                      type="text"
                                      name="code"
                                      onChange={e => {
                                        const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
                                        setFieldValue('code', value);
                                      }}
                                      FormGroupClassName={'col-lg-4 col-md-6 col-sm-12'}
                                      LabelClassName={'col-form-label'}
                                      onBlur={handleBlur}
                                      value={values.code}
                                      label="Coupon Code"
                                      error={errors?.code}
                                      touched={touched.code}
                                    />{' '}
                                    <InputFromUser
                                      placeholder={'Coupon Quantity'}
                                      type="number"
                                      name="couponQuantity"
                                      onChange={handleChange}
                                      FormGroupClassName={'col-lg-4 col-md-6 col-sm-12'}
                                      LabelClassName={'col-form-label'}
                                      onBlur={handleBlur}
                                      value={values.couponQuantity}
                                      label="Coupon Quantity"
                                      error={errors?.couponQuantity}
                                      touched={touched.couponQuantity}
                                    />
                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                      <label className="col-form-label">Service Type</label>
                                      <Select
                                        placeholder="Select Service Type"
                                        style={{ width: '100%' }}
                                        value={values.bookingFor}
                                        onChange={value => setFieldValue('bookingFor', value)}
                                        onBlur={() => handleBlur({ target: { name: 'bookingFor' } })}
                                      >
                                        <Option value="Appointment">Appointment</Option>
                                        <Option value="Treatment">Treatment</Option>
                                        <Option value="Service">Service</Option>
                                        <Option value="Program">Program</Option>
                                        <Option value="DetoxRetreat">DetoxRetreat</Option>
                                        <Option value="Solution">Solution</Option>
                                      </Select>
                                      {errors?.bookingFor && touched.bookingFor && (
                                        <div className="text-danger">{errors.bookingFor}</div>
                                      )}
                                    </div>
                                  </div>

                                  <div className="row">
                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                      <label className="col-form-label">Platform Type</label>
                                      <Select
                                        placeholder="Select Platform Type"
                                        style={{ width: '100%' }}
                                        value={values.platformType}
                                        onChange={value => setFieldValue('platformType', value)}
                                        onBlur={() =>
                                          handleBlur({ target: { name: 'platformType' } })
                                        }
                                      >
                                        <Option value="Simulation">Simulation</Option>
                                        <Option value="Website">Website</Option>
                                      </Select>
                                      {errors?.platformType && touched.platformType && (
                                        <div className="text-danger">{errors.platformType}</div>
                                      )}
                                    </div>

                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                      <label className="col-form-label">Discount Type</label>
                                      <Select
                                        placeholder="Select Discount Type"
                                        style={{ width: '100%' }}
                                        value={values.type}
                                        onChange={value => setFieldValue('type', value)}
                                        onBlur={() =>
                                          handleBlur({ target: { name: 'type' } })
                                        }
                                      >
                                        <Option value="Flat">Flat</Option>
                                        <Option value="Percentage">Percentage</Option>
                                      </Select>
                                      {errors?.type && touched.type && (
                                        <div className="text-danger">{errors.type}</div>
                                      )}
                                    </div>

                                    <InputFromUser
                                      placeholder={'Value'}
                                      type="text"
                                      name="value"
                                      onChange={handleChange}
                                      FormGroupClassName={'col-lg-4 col-md-6 col-sm-12'}
                                      LabelClassName={'col-form-label'}
                                      onBlur={handleBlur}
                                      value={values.value}
                                      label="Value (Rs. or %)"
                                      error={errors?.value}
                                      touched={touched.value}
                                    />
                                  </div>

                                  <div className="row">
                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                      <label className="col-form-label">Validity Period</label>
                                      <DatePicker.RangePicker
                                        style={{ width: '100%' }}
                                        value={values.dateRange}
                                        onChange={val => setFieldValue('dateRange', val)}
                                        className="form-control"
                                        format="YYYY-MM-DD"
                                      />
                                      {errors?.dateRange && touched.dateRange && (
                                        <div className="text-danger">{errors.dateRange}</div>
                                      )}
                                    </div>
                                    <InputFromUser
                                      placeholder={'Per User Usage Limit'}
                                      type="number"
                                      name="personUsageLimit"
                                      onChange={handleChange}
                                      FormGroupClassName={'col-lg-4 col-md-6 col-sm-12'}
                                      LabelClassName={'col-form-label'}
                                      onBlur={handleBlur}
                                      value={values.personUsageLimit}
                                      label="Per User Usage Limit"
                                      error={errors?.personUsageLimit}
                                      touched={touched.personUsageLimit}
                                    />
                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                      <label className="col-form-label">Is Active</label>
                                      <Select
                                        placeholder="Select"
                                        style={{ width: '100%' }}
                                        value={values.isActive}
                                        onChange={value => setFieldValue('isActive', value)}
                                        onBlur={() =>
                                          handleBlur({ target: { name: 'isActive' } })
                                        }
                                      >
                                        <Option value={true}>Yes</Option>
                                        <Option value={false}>No</Option>
                                      </Select>
                                      {errors?.isActive && touched.isActive && (
                                        <div className="text-danger">{errors.isActive}</div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-12 mt-4">
                                    <div className="doctor-submit text-end">
                                      <button
                                        type="submit"
                                        onClick={() => {
                                          handleSubmit();
                                        }}
                                        className="btn btn-primary submit-form me-2"
                                        disabled={isSubmitting}
                                      >
                                        Submit
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-primary cancel-form"
                                        onClick={() => {
                                          window.location.href = `/coupon-management?page=${pageValue}`;
                                        }}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          }}
                        </Formik>
                      </div>
                    </div>
                  </Spin>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default AddCoupon;
